var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 16,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C4.27614 0 4.5 0.223858 4.5 0.5C4.5 0.74546 4.32312 0.949608 4.08988 0.991944L4 1H1V11H4C4.24546 11 4.44961 11.1769 4.49194 11.4101L4.5 11.5C4.5 11.7455 4.32312 11.9496 4.08988 11.9919L4 12H0.5C0.25454 12 0.0503916 11.8231 0.00805567 11.5899L0 11.5V0.5C0 0.25454 0.176875 0.0503916 0.410124 0.00805567L0.5 0H4ZM13.5 0L13.5899 0.00805567C13.794 0.0450996 13.9549 0.206031 13.9919 0.410124L14 0.5V11.5L13.9919 11.5899C13.9549 11.794 13.794 11.9549 13.5899 11.9919L13.5 12H10L9.91012 11.9919C9.70603 11.9549 9.5451 11.794 9.50806 11.5899L9.5 11.5L9.50806 11.4101C9.5451 11.206 9.70603 11.0451 9.91012 11.0081L10 11H13V1H10L9.91012 0.991944C9.67688 0.949608 9.5 0.74546 9.5 0.5C9.5 0.25454 9.67688 0.0503916 9.91012 0.00805567L10 0H13.5ZM3 4V8H2V4H3ZM8 4V8H6V4H8ZM10 4V8H9V4H10ZM12 4V8H11V4H12ZM5 4V8H4V4H5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpc);
export default __webpack_public_path__ + "static/media/UPC.810be2f330395f9a9aa82b778fc95d6c.svg";
export { ForwardRef as ReactComponent };